/**
 * Ruoli con privilegi di amministratore completi.
 * Aggiungere qui nuovi ruoli superuser senza dover toccare
 * ogni singolo componente.
 */
const ADMIN_ROLES = ['Admin', 'Sviluppatore'];

/**
 * Restituisce true se l'utente ha privilegi admin (Admin o Sviluppatore).
 * Accetta sia l'oggetto user che la stringa ruolo.
 * @param {object|string|null} userOrRole
 */
export function isAdmin(userOrRole) {
    const ruolo = typeof userOrRole === 'string'
        ? userOrRole
        : userOrRole?.ruolo;
    return ADMIN_ROLES.includes(ruolo);
}

/**
 * Shorthand: true solo se il ruolo è esattamente 'Sviluppatore'.
 */
export function isSviluppatore(userOrRole) {
    const ruolo = typeof userOrRole === 'string'
        ? userOrRole
        : userOrRole?.ruolo;
    return ruolo === 'Sviluppatore';
}
